export const validateQuantity = (value) => {
  if (value === "" || value === null || value === undefined) {
    return "Quantity is required";
  }

  const parsedValue = Number.parseFloat(value);

  if (!Number.isFinite(parsedValue)) {
    return "Quantity is required";
  }

  if (parsedValue < 1) {
    return "Quantity must be at least 1.";
  }

  return true;
};
